export enum ZoneFeedbackLabels {
  none = "none",
  clean = "clean",
  neutral = "neutral",
  dirty = "dirty",
  veryDirty = "very_dirty",
}
